import { IDropdownOption } from '@fluentui/react';

export const topSuggestedCurrencyCodes: IDropdownOption[] = [
  {
    key: 'suggested_USD',
    text: 'USD',
  },
  {
    key: 'suggested_EUR',
    text: 'EUR',
  },
];

export const savedDividendCurrency = (currencyCode: string): IDropdownOption[] => {
  return [
    {
      key: `suggested_${currencyCode}`,
      text: currencyCode,
    },
  ];
};
